/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyResponse } from './workingModeApplyResponse';

export type GenericApiResponseWorkingModeApplyResponseData = WorkingModeApplyResponse | null;
